export const getTotalCost = (cart) => {
  const productDisc = getTotalDiscount(cart);
  const subTotal = getSubTotalCost(cart);
  return subTotal - productDisc;
};

export const getSubTotalCost = (cart) => {
  return Object.values(cart).reduce((acc, product) => {
    const price =
      product.movile?.price ||
      product.accesory?.price ||
      product.chip?.price ||
      product.cash_card?.card_catalogue?.amount ||
      product.balance_transfer?.amount ||
      product.phone_plan?.amount ||
      0;
    return acc + price;
  }, 0);
};

export const getTotalDiscount = (cart) => {
  return Object.values(cart).reduce((acc, product) => {
    const discount =
      product.movile?.discount ||
      product.accesory?.discount ||
      product.balance_transfer?.discount ||
      product.cash_card?.discount ||
      0;
    return acc + discount;
  }, 0);
};

export const validateChips = (cart, numbersAssociateToIccid) => {
  let result = { validationCorrect: true };
  const chipProducts = Object.values(cart).filter((item) => item.chip);
  if (chipProducts.length) {
    if (!numbersAssociateToIccid.length) {
      result = {
        validationCorrect: false,
        text: "Es necesario asociar un número de teléfono al chip(s) vendido",
      };
    } else if (numbersAssociateToIccid.length !== chipProducts.length) {
      console.log("numbersAssociateToIccid", numbersAssociateToIccid);
      result = {
        validationCorrect: false,
        text:
          "Algunos de los chips agregados al carrito no tiene # de teléfono asociado",
      };
    }
  }
  return result;
};

export const showProductLabelInResume = (productArray, productType) => {
  return productArray
    .filter((item) => item.productTypeId === productType)
    .some((item) => item.units >= 1);
};

export const showChipLabelInResume = (cart) => {
  return Object.values(cart).some((item) => item.chipId);
};

export const getTotalCostByUnits = (units, price) => {
  return units * price;
};

export const getMovileTotalDiscounts = (cart) => {
  return Object.values(cart).reduce((acc, product) => {
    // console.log("prod", product);
    const discount = product.movile?.discount || 0;
    return acc + discount;
  }, 0);
};

export const getAccesoryTotalDiscounts = (cart) => {
  return Object.values(cart).reduce((acc, product) => {
    // console.log("prod", product);
    const discount = product.accesory?.discount || 0;
    return acc + discount;
  }, 0);
};
